
<div class="wrapper" style="margin-top: 28px">
    <div class="table2" style="margin-bottom: 10px">
        <div class="row2">
            <div class="cell2 d-flex text-left" style="box-shadow: none">
                <div class="form-group">
                    <span class="fa fa-search form-control-icon"></span>
                    <input type="text" class="form-control" [(ngModel)]="filteredStatus" style="width: 300px;"
                        placeholder="Search" />
                </div>
            </div>
            <div class="cell2 myCell pl-lg-2 mt-2 text-right">
                <button (click)="addUser()"
                    style="background-color: #4A9F37;border-radius: 8px;color: white;" class="btn mb-1">
                    <i class="fas fa-plus"></i> Add user
                </button>
            </div>
        </div>
    </div>

    <table class="table text-center" style="box-shadow: none">
        <thead>
            <tr>
                <th scope="col">S.No</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Status</th>
                <th scope="col">Created on</th>
                <th scope="col">Action</th>
            </tr>
        </thead>
        <tbody style="color: gray; font-weight: 600" *ngIf="waitlistUsers.length">
            <tr *ngFor="let i of waitlistUsers
                | nameFilter: filteredStatus; let idx = index">
                <th scope="row">{{ idx + 1 }}</th>
                <td>{{ i.name }}</td>
                <td>{{ i.user_email }}</td>
                <td>{{ i.email_status }}</td>
                <td>{{ i.createdAt | date:'medium' }}</td>
                <td>
                    <button class="btn btn-primary" (click)="onSend(i)">Send</button>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!waitlistUsers.length">
            <tr>
                <td colspan="5">
                    <h3 class="mt-2" style="color: #d6d6d6;">No data to show</h3>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading list(s)...</p>
</ngx-spinner>